import { useTranslation } from 'react-i18next'

import { Text } from '@mercai/clever'

import styles from './general-jtbd.module.css'
import { getConversationJtbdDisplay } from './general-jtbd.constants'
import { GeneralJtbdProps } from './general-jtbd.type'

export const GeneralJtbd = ({ evaluation }: GeneralJtbdProps) => {
  const { t } = useTranslation('screenAiCenter')

  const isCompleted = evaluation?.isJtbdCompleted || false
  const observation = evaluation?.jtbdCompletedObservation || ''
  const statusData = getConversationJtbdDisplay(t, isCompleted)

  if (!evaluation?.generalNote) {
    return (
      <div className={styles['jtbd-section']}>
        <Text>{t('conversationShowGeneralJtbdEmpty')}</Text>
      </div>
    )
  }

  return (
    <div className={styles['jtbd-section']}>
      <Text variant="text-medium" className={styles.bold}>
        {t('conversationShowGeneralJtbdSubtitle')}
      </Text>

      <div className={`${styles['jtbd-banner']} ${styles[statusData.color]}`}>
        <div className={styles['banner-icon']}>{statusData.emoji}</div>
        <div className={styles['banner-content']}>
          <Text
            variant="text-medium"
            className={`${styles['banner-status']} ${styles[statusData.color]}`}
          >
            {statusData.text}
          </Text>
          <Text variant="text-small" className={styles['banner-observation']}>
            {observation || t('conversationShowGeneralJtbdNoObservation')}
          </Text>
        </div>
      </div>
    </div>
  )
}
